import * as Sentry from '@sentry/react';
import { version } from '../../package.json';
import config from '~/config';

const getSentryOptions = (): Sentry.BrowserOptions => {
  return {
    dsn: 'https://c6b6d02950cb4c3ba6939ee94e412307@o575998.ingest.sentry.io/5743151',
    release: version,
    enabled: config.environment !== 'dev',
    environment: config.environment,
    // block chatbot errors from being reported to Sentry
    denyUrls: [/niceincontact\.com/, /amazonaws\.com/],
  };
};

export const initSentry = () => {
  Sentry.init(getSentryOptions());
};
